module.exports = __webpack_public_path__ + "img/A1 (2).b3e863f0.jpg";